// *********************************************************************************************************************
// Custom JavaScript
// *********************************************************************************************************************

// =====================================================================================================================
// Splide
// =====================================================================================================================
import Splide from '@splidejs/splide'

document.addEventListener( 'DOMContentLoaded', function () {
    // Main Product Slider
    let thumbnails = new Splide( '#product-slider',{
        type: 'loop',
        perPage: 1,
        arrows: false,
        pagination: false,
    } );

    // Main Product Thumbnail Slider
    let main = new Splide( '#product-thumbnail-slider', {
        fixedWidth: 125,
        fixedHeight: 125,
        gap: 20,
        rewind: true,
        pagination: false,
        isNavigation: true,
        arrows: false,
        perPage: 3,
    } );

    main.sync( thumbnails );
    main.mount();
    thumbnails.mount();
  } );

  document.addEventListener( 'DOMContentLoaded', function () {
    // Related Products Slider
    new Splide( '#related-products-slider',{
        type: 'loop',
        perPage: 3,
        breakpoints: {
            768: {
                perPage: 2,
            },

            576: {
                perPage: 1,
            },
        },
        pagination: false,
        classes: {
            arrows: 'splide__arrows red-arrows',
            arrow : 'splide__arrow red-arrow',
            prev  : 'splide__arrow--prev red-arrow-prev',
            next  : 'splide__arrow--next red-arrow-next',
      },
    } ).mount();

  } );

// =================================================================================================================
// Breakpoints
// =================================================================================================================

// SET YOUR BREAKPOINT HERE
// Object of CSS breakpoints in pixels. Copy what you have in SCSS. Goes from smallest to largest.
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1360,
}

/**
 * Get Current Breakpoint
 * Returns the name of the current breakpoint
 *
 * @param {object} breakpoints All of the CSS breakpoints. The key is the name of the breakpoint and the value is the width
 * @param {boolean} logBreakpoint Whether to log the breakpoint to the console or not
 * @param {string} currentBreakpoint The name of the current breakpoint
 */
function getCurrentBreakpoint(breakpoints, logBreakpoint= false, currentBreakpoint){
    // Get the window width
    let width = window.innerWidth;

    // Set the base breakpoint to the smallest one
    let breakpoint = Object.keys(breakpoints)[0];

    // Loop over the breakpoints object
    Object.entries(breakpoints).forEach(entry => {
        const [breakpointName, breakpointWidth] = entry;
        if (width > breakpointWidth ) {
            breakpoint = breakpointName;
        }
    });

    // If logging in enabled
    if (logBreakpoint) {
        if (currentBreakpoint){
            if (currentBreakpoint !== breakpoint){
                console.log("breakpoint:", breakpoint);
            }
        } else {
            console.log("breakpoint:", breakpoint);
        }
    }

    return breakpoint;
}

// Set breakpoint on page load
let breakpointCurrent = getCurrentBreakpoint(breakpoints, true);


// Change breakpoint on screen resize
window.addEventListener('resize', function (){
    breakpointCurrent = getCurrentBreakpoint(breakpoints, true, breakpointCurrent);
});



(function( $ ){
    //start splide slider
    let splider = $('#splide-general');
    if (splider.length) {
        new Splide('.splide', {
            type: 'loop',
            perPage: 7,
            pagination: false,
            breakpoints: {
                1024: {
                    perPage: 2,

                },
                600: {
                    perPage: 1,
                },
            },

            focus: 0,
            omitEnd: true,
        }).mount();
    }

    let splideProduct = $('#splide-product');
    if (splideProduct.length){
        new Splide( '.splidep', {
            type   : 'loop',
            drag   : 'free',
            snap   : true,
            perPage: 1,
            // focus  : 0,
            omitEnd: true,
            arrows:false,
            pagination:true,
            // omitEnd: true,
        } ).mount();
    }

    //caches a jQuery object containing the header element
    let header = $("#main-nav");
    $(window).scroll(function() {
        let scroll = $(window).scrollTop();

        if (scroll >= 100) {
            header.addClass("compactHeader");
        } else {
            header.removeClass("compactHeader");
        }
    });



    $("#contact-hours").html(function(_, html) {
        return html.replace(/\|/g, "<br />");
    });


})(jQuery);
//end slider
